import { defineCustomElement } from 'vue'
import { createVuetify } from 'vuetify'
import { createPinia } from 'pinia'
import { md3 } from 'vuetify/blueprints'
import MomentAdapter from '@date-io/moment'

import FediView from './components/FediView.ce.vue'

const pinia = createPinia()
const vuetify = createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'system', // 'system' | 'light' | 'dark'
  },
  date: {
    adapter: MomentAdapter,
  },
})

export const FediViewCE = defineCustomElement(FediView, {
  configureApp(app) {
    app.use(pinia)
    app.use(vuetify)
  },
})

customElements.define('fedi-view', FediViewCE)
